export default "__VITE_ASSET__B$SCBi_k__"